<template>
  <p class="text-xs font-normal leading-4" data-test="TPCaption">
    <slot />
  </p>
</template>
